import { createUseStyles } from 'react-jss';

import { FontWeight, mediaQuery } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ breakpoints, layout }: ITheme) => ({
    container: {
      padding: [0, '48px'],

      [mediaQuery(breakpoints.tablet)]: {
        padding: [0, '24px'],
      },
    },
    root: {
      display: 'flex',
      gap: '135px',

      padding: '72px 56px 56px',
      overflow: 'hidden',
      background: layout.background,
      borderRadius: '32px',

      maxWidth: layout.maxWidth,
      margin: 'auto',

      [mediaQuery(breakpoints.tablet)]: {
        flexDirection: 'column',
        padding: '32px 8px',
        gap: '32px',
        alignItems: 'center',
        justifyContent: 'stretch',
      },
    },
    text: {
      flex: 1,

      [mediaQuery(breakpoints.tablet)]: {
        padding: '0 32px',
      },
    },
    label: {
      fontSize: '20px !important',
      color: 'var(--x-text-color-2) !important',

      [mediaQuery(breakpoints.tablet)]: {
        textAlign: 'center',
      },
    },
    title: {
      fontSize: '60px !important',
      lineHeight: '71px',
      fontWeight: `${FontWeight.Medium} !important`,
      marginBottom: '24px',

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: '42px !important',
        lineHeight: '42px !important',
        textAlign: 'center',
      },
    },
    description: {
      fontSize: '16px !important',
      lineHeight: '24px',
      fontWeight: `${FontWeight.Medium} !important`,

      [mediaQuery(breakpoints.tablet)]: {
        textAlign: 'center',
      },
    },
    questions: {
      position: 'relative',
      flex: 2,
      width: '100%',

      display: 'flex',
      flexDirection: 'column',
      gap: '40px',
      alignItems: 'center',
    },
    hiddenQuestion: {
      display: 'none',
    },
    accordion: {
      width: '100%',

      [mediaQuery(breakpoints.tablet)]: {
        padding: '0 16px',
      },
    },
    question: {
      width: '100%',

      padding: '32px',
      borderRadius: '32px',

      background: 'var(--x-bg-2)',
    },
    questionTitle: {
      fontSize: '24px !important',
      fontWeight: `${FontWeight.Medium} !important`,

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: '16px !important',
      },
    },
    questionAnswer: {
      fontSize: '16px !important',
      lineHeight: '24px',
      fontWeight: `${FontWeight.Medium} !important`,
    },
    ctaButton: {
      padding: '12px 24px',
    },
  }),
  {
    name: 'faq-collapsed-section',
  },
);

export default useStyles;
